(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/section-odds-live/assets/javascripts/ui-updates.js') >= 0) return;  svs.modules.push('/components/banner_layouts/section-odds-live/assets/javascripts/ui-updates.js');
"use strict";

var _svs$banner_layouts$s, _svs$banner_layouts;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  productIds
} = svs.components.lbUtils.sportProducts;
const {
  getFormattedEyebrow,
  Queue,
  resolveCallToActions,
  normalizeCta,
  EventState,
  getMatchMinuteFromMatchClock
} = svs.banner_layouts.section_odds_live.helpers;
const logger = svs.core.log.getLogger('banner_layouts:section-odds-live');
const {
  normalize: {
    normalizeOutcomes
  },
  constants: {
    SocketMessageType,
    BetOfferTypeId,
    PeriodId
  }
} = svs.components.oddset.kambiOffering.common;
const {
  buildEventDeepLink
} = svs.components.oddset.kambiOffering;
const bannerModel = (_svs$banner_layouts$s = (_svs$banner_layouts = svs.banner_layouts) === null || _svs$banner_layouts === void 0 || (_svs$banner_layouts = _svs$banner_layouts.section_odds_live) === null || _svs$banner_layouts === void 0 || (_svs$banner_layouts = _svs$banner_layouts.data) === null || _svs$banner_layouts === void 0 ? void 0 : _svs$banner_layouts.bannerModel) !== null && _svs$banner_layouts$s !== void 0 ? _svs$banner_layouts$s : {};

class SectionUI {
  constructor(shouldReduceMotion) {
    _defineProperty(this, "cubes", []);
    _defineProperty(this, "offset", {
      x: 0,
      y: 0
    });
    _defineProperty(this, "shouldReduceMotion", false);
    _defineProperty(this, "animationComplete", false);
    _defineProperty(this, "requestAnimationFrameId", null);
    _defineProperty(this, "SPEED", 30);
    _defineProperty(this, "timerId", void 0);
    _defineProperty(this, "isLive", bannerModel.isLive);
    _defineProperty(this, "previousOutcomes", bannerModel.outcomes);
    this.shouldReduceMotion = shouldReduceMotion;
    this.SPEED = shouldReduceMotion ? 0 : 30;
    this.update = this.update.bind(this);
  }

  handleElement(element) {
    const brandCube = element.querySelector('.brand-cube');
    if (brandCube) {
      brandCube.removeEventListener('animationend', this.onAnimationComplete);
      brandCube.addEventListener('animationend', this.onAnimationComplete);
      const cube = brandCube.querySelector('.brand-cube-faces');
      if (cube) {
        this.cubes.push(cube);
      }
    }
  }

  updateCube(cube) {
    var _cube$dataset;
    const productId = Number(cube === null || cube === void 0 || (_cube$dataset = cube.dataset) === null || _cube$dataset === void 0 ? void 0 : _cube$dataset.id);
    const delta = performance.now() * this.SPEED / 1000 % 360;
    this.offset.x = Math.cos(delta * Math.PI / 180) / 3;
    this.offset.y = Math.sin(delta * Math.PI / 180) / 3;
    let rx = -this.offset.x * 10 - 10;
    let ry = this.offset.y * 50 + 40;
    let rz = 8;
    switch (productId) {
      case productIds.FULLTRAFF:
      case productIds.MALTIPSET:
        rz = -8;
        break;
      case productIds.BINGO:
        rx = 7 - this.offset.x * 20;
        ry = 43 + this.offset.y * 50;
        rz = 351;
        break;
      default:
    }
    const sizeMatch = cube.offsetHeight;
    const fp = Math.min(1, cube.children[0].getBoundingClientRect().width / sizeMatch);
    const lp = Math.min(1, cube.children[3].getBoundingClientRect().width / sizeMatch);
    const tp = Math.min(1, cube.children[4].getBoundingClientRect().height / (sizeMatch * 0.5));
    const bp = Math.min(1, cube.children[5].getBoundingClientRect().height / (sizeMatch * 0.75));
    cube.style.transform = "rotateX(".concat(rx, "deg) rotateY(").concat(ry, "deg) rotateZ(").concat(rz, "deg)");
    cube.children[0].style.filter = "brightness(".concat(fp, ")");
    cube.children[3].style.filter = "brightness(".concat(lp, ")");
    cube.children[4].style.filter = "brightness(".concat(tp, ")");
    cube.children[5].style.filter = "brightness(".concat(bp + 0.75, ")");
    cube.dataset.delta = delta;
  }
  update() {
    if (this.cubes.length) {
      this.cubes.forEach(cube => this.updateCube(cube));
      if (!this.shouldReduceMotion || !this.animationComplete) {
        this.requestAnimationFrameId = requestAnimationFrame(this.update);
      }
    }
  }

  handleSocketUiUpdate(type, payload, message) {
    const banner = SectionUI.getBanner(bannerModel.eventId);
    if (!banner || (payload === null || payload === void 0 ? void 0 : payload.eventId) !== bannerModel.eventId) {
      return;
    }
    switch (type) {
      case SocketMessageType.BetOfferOddsUpdated:
        {
          const newOutcomes = this.previousOutcomes.map(prevOutcome => {
            const updOutcome = payload.outcomes.find(updOutcome => updOutcome.id === prevOutcome.id);
            if (updOutcome) {
              return _objectSpread(_objectSpread({}, prevOutcome), updOutcome);
            }
            return prevOutcome;
          });
          this.previousOutcomes = newOutcomes;
          this.handleBetOfferOddsUpdated(banner, {
            eventId: payload.eventId,
            outcomes: normalizeOutcomes(newOutcomes, BetOfferTypeId.Match)
          });
          break;
        }
      case SocketMessageType.EventScoreUpdated:
        this.handleEventScoreUpdated(banner, payload);
        break;



      case SocketMessageType.MatchClockUpdated:
        this.handleMatchClockUpdated(banner, payload);
        break;
      default:
        logger.debug("Unhandled socket update (".concat(SocketMessageType.toString(type), ")"), message);
    }
  }

  async handleMatchClockUpdated(banner, payload) {
    const {
      eventId,
      matchClock
    } = payload;
    logger.debug('MatchClockUpdated', eventId, matchClock);
    this.matchClockUpdate(banner, matchClock);
    if (matchClock.running) {
      this.timerId = setTimeout(() => this.updateTimer(banner, _objectSpread(_objectSpread({}, matchClock), {}, {
        minute: matchClock.minute + 1
      })), (60 - matchClock.second) * 1000);
    } else {
      clearTimeout(this.timerId);
    }
  }

  updateTimer(banner, matchClock) {
    clearTimeout(this.timerId);
    this.matchClockUpdate(banner, matchClock);
    this.timerId = setTimeout(() => this.updateTimer(banner, _objectSpread(_objectSpread({}, matchClock), {}, {
      minute: matchClock.minute + 1
    })), 60000);
  }

  async matchClockUpdate(banner, matchClock) {
    const currentMatchClock = getMatchMinuteFromMatchClock(matchClock);
    this.updateEyebrowUI(banner, {
      isLive: true,
      liveTime: currentMatchClock
    });
    const timeWrapper = banner.querySelector('.hero-time');
    await new Promise(resolve => {
      timeWrapper.classList.add('hero-time-out');
      timeWrapper.addEventListener('transitionend', () => {
        timeWrapper.classList.add('hero-time-in');
        timeWrapper.classList.remove('hero-time-out');
        resolve();
      }, {
        once: true
      });
    });
    setTimeout(() => {
      timeWrapper.classList.remove('hero-time-in');
    }, 100);
  }

  onAnimationComplete(e) {
    switch (e.animationName) {
      case 'cube-scale':
        this.animationComplete = true;
        break;
      default:
    }
  }
  initialize() {
    this.requestAnimationFrameId = requestAnimationFrame(this.update);
  }
  reset() {
    cancelAnimationFrame(this.requestAnimationFrameId);
  }

  transitionIntoLive(banner, _ref) {
    let {
      eventId,
      matchClock,
      score
    } = _ref;
    if (this.isLive) {
      return;
    }
    const queue = new Queue();
    const title = banner.querySelector('.hero-event-title');
    this.isLive = true;
    title.style.transition = 'opacity .6s cubic-bezier(0.5, 1, 0.89, 1), max-height .3s cubic-bezier(0.45, 0, 0.55, 1)';
    queue.add(next => {
      title.style.opacity = 0;
      title.addEventListener('transitionend', next, {
        once: true
      });
    }).add(next => {
      var _score$home, _score$away;
      title.style.maxHeight = "".concat(title.getBoundingClientRect().height, "px");
      title.classList.add('hero-event-title-live');
      this.updateMatchInfoUI(banner, {
        score: {
          home: (_score$home = score === null || score === void 0 ? void 0 : score.home) !== null && _score$home !== void 0 ? _score$home : 0,
          away: (_score$away = score === null || score === void 0 ? void 0 : score.away) !== null && _score$away !== void 0 ? _score$away : 0
        },
        isLive: true
      });
      next();
    }).add(next => {
      title.style.maxHeight = "".concat(title.scrollHeight + 20, "px");
      title.addEventListener('transitionend', next, {
        once: true
      });
    }).add(next => {
      title.style.opacity = 1;
      title.addEventListener('transitionend', next, {
        once: true
      });
    }).add(() => {
      title.removeAttribute('style');
      this.handleMatchClockUpdated(banner, {
        eventId,
        matchClock
      });
    }).run();
  }

  handleBetOfferOddsUpdated(banner, payload) {
    const {
      eventId,
      outcomes
    } = payload;
    logger.debug('BetOfferOddsUpdated', eventId, outcomes);
    this.updateCtaUI(banner, {
      outcomes,
      event: bannerModel.event
    });
  }

  handlePreMatchPollUpdate(payload) {
    const {
      eventId,
      event,
      outcomes
    } = payload;
    const banner = SectionUI.getBanner(eventId);
    if (!banner) {
      return;
    }
    if (!this.isLive) {
      const {
        time
      } = getFormattedEyebrow(event);
      this.updateEyebrowUI(banner, {
        startTimeString: time
      });
    }
    this.updateCtaUI(banner, {
      outcomes,
      event,
      eventId
    });
  }

  handleEventScoreUpdated(banner, payload) {
    var _score$home2, _home$dataset, _score$away2, _away$dataset;
    const {
      score
    } = payload;
    logger.debug('EventScoreUpdated', payload);
    const home = banner.querySelector('.js-hero-score-home');
    const away = banner.querySelector('.js-hero-score-away');
    const lastHome = (_score$home2 = score === null || score === void 0 ? void 0 : score.home) !== null && _score$home2 !== void 0 ? _score$home2 : home === null || home === void 0 || (_home$dataset = home.dataset) === null || _home$dataset === void 0 ? void 0 : _home$dataset.score;
    const lastAway = (_score$away2 = score === null || score === void 0 ? void 0 : score.away) !== null && _score$away2 !== void 0 ? _score$away2 : away === null || away === void 0 || (_away$dataset = away.dataset) === null || _away$dataset === void 0 ? void 0 : _away$dataset.score;
    this.updateMatchInfoUI(banner, {
      score: {
        home: lastHome,
        away: lastAway
      },
      isLive: this.isLive
    });
    const transitionComplete = (element, newScore) => {
      setTimeout(() => {
        element.firstChild.remove();
        element.classList.remove('hero-update-score');
        element.dataset.score = newScore;
        element.removeAttribute('style');
        delete element.dataset.end;
      }, 300);
    };
    requestAnimationFrame(() => {
      if (score.home !== lastHome) {
        home.addEventListener('transitionend', e => transitionComplete(e.target, score.home), {
          once: true
        });
        home.classList.add('hero-update-score');
        home.style.width = "".concat(home.dataset.end, "px");
      }
      if (score.away !== lastAway) {
        away.addEventListener('transitionend', e => transitionComplete(e.target, score.away), {
          once: true
        });
        away.classList.add('hero-update-score');
        away.style.width = "".concat(away.dataset.end, "px");
      }
    });
  }







  updateEyebrowUI(banner, _ref2) {
    let {
      isLive = this.isLive,
      liveTime,
      bannerTitle = bannerModel.bannerTitle,
      startTimeString
    } = _ref2;
    const eyebrow = banner.querySelector('.js-hero-eyebrow');
    const useMatchclockToggle = svs.core.detect.feature('ft-oddslive-ad-matchclock');
    eyebrow.outerHTML = svs.banner_layouts.section_odds_live.templates.eyebrow({
      useMatchclockToggle,
      isLive,
      liveTime,
      bannerTitle,
      startTimeString
    });
    const heroTimeEl = eyebrow.querySelector('.hero-time');
    if (heroTimeEl && liveTime) {
      heroTimeEl.setAttribute('aria-label', liveTime === 1 ? "".concat(liveTime, " minut spelad") : "".concat(liveTime, " minuter spelade"));
    }
  }

  updateMatchInfoUI(banner, _ref3) {
    let {
      isLive = this.isLive,
      event = bannerModel.event,
      score
    } = _ref3;
    const matchInfo = banner.querySelector('.hero-event-meeting-info');
    matchInfo.outerHTML = svs.banner_layouts.section_odds_live.templates.match_info({
      isLive,
      event,
      score
    });
  }

  updateCtaUI(banner, _ref4) {
    let {
      outcomes,
      event = bannerModel.event
    } = _ref4;
    const cta = banner.querySelector('.hero-actions');
    const eventUrl = buildEventDeepLink(event);
    const {
      betActions,
      eventCta
    } = resolveCallToActions(outcomes, eventUrl);
    const callToActions = normalizeCta(betActions, bannerModel.actionDescriptionId, bannerModel.callToActions);
    cta.outerHTML = svs.banner_layouts.section_odds_live.templates.cta({
      isBetAction: Boolean(betActions.length),
      event,
      callToActions,
      actionDescriptionId: bannerModel.actionDescriptionId,
      trackingString: bannerModel.trackingString,
      eventCta
    });
  }
  static removeChildren(element) {
    if (element.firstChild) {
      while (element.firstChild) {
        element.firstChild.remove();
      }
    }
    return element;
  }
  static getBanner(eventId) {
    return document.querySelector(".js-hero-v2[data-eventid=\"".concat(eventId, "\"]"));
  }
}
setGlobal('svs.banner_layouts.section_odds_live.ui', {
  SectionUI
});

 })(window);